export default "__VITE_ASSET__89f5bd55__"